import '@fsa/sbx-core-react-mfe/reactDomFindDomNodePolyfill';
import('./src/bootstrap');
import('@fsa/app-info');
